export const CCQ_BADGE_CLASS = 'paragraph-small bold px-1 border rounded-1 zocks-bg-color-gray-100 zocks-border-color-gray-200'

export const CCQ_SECONDARY_BUTTON_CLASS = 'button-small zocks-border-0.5 zocks-border-color-gray-300'
